<div class="your-information">
  @if (mobile() === true) {
  <div class="your-information__course-summary-container">
    <ng-container *ngTemplateOutlet="courseSummaryTemplate"></ng-container>
  </div>
  }

  <lx-layout [title]="title()" [subtitle]="subtitle()">
    <div layout-main>
      <lx-enrolment-form [form]="form" [submitted]="submitted()"></lx-enrolment-form>
    </div>
    <div layout-sidebar>
      @if (mobile() === false) {
      <ng-container *ngTemplateOutlet="courseSummaryTemplate"></ng-container>
      }
      <div class="your-information__secure-place">
        <lx-button
          id="btn-next"
          aria-label="Secure my place"
          i18n-aria-label
          [block]="true"
          [buttonStyle]="'primary'"
          [lxGAClickEvent]="secureMyPlaceEventName"
          data-qa="next-button"
          (buttonClick)="onSecureMyPlace()"
        >
          <span i18n>Secure my place </span>
          <span class="estimated-price__amount">{{ price() | lxPrice : { currency: currency(), showCurrency: false } }}</span
          ><span class="estimated-price__currency">{{ currency() }}</span>
        </lx-button>
      </div>
    </div>
  </lx-layout>
</div>

<ng-template #courseSummaryTemplate>
  <p-card>
    <lx-course-summary
      [courseSummary]="courseSummary()"
      [withEditButton]="true"
      [gaEvent]="editCourseEventName"
      (onEditClick)="goBackToBuildYourCourse()"
    ></lx-course-summary>
  </p-card>
</ng-template>
